import {
  isFilterActive,
  transformToWhereCondition,
  serializeFilters,
  deserializeFilters,
  getSortByValue
} from "@scayle/storefront-core";
import { computed } from "vue";
import { getCurrentPage } from "../../utils/route.js";
import { useRoute, useRouter } from "#imports";
const DEFAULT_QUERY_KEYS = ["page", "sort", "term"];
function queryValueToString(value) {
  return Array.isArray(value) ? value.map((v) => v?.toString()).filter(Boolean).join(",") : value?.toString();
}
const isEqual = (x, y) => {
  if (Object.is(x, y)) {
    return true;
  }
  if (typeof x !== "object" || x === null || typeof y !== "object" || y === null) {
    return x === y;
  }
  const keys = Object.keys(x);
  return keys.length === Object.keys(y).length && keys.every((key) => Reflect.has(y, key) && isEqual(x[key], y[key]));
};
export function useQueryFilterState(options = {}) {
  const router = useRouter();
  const route = useRoute();
  const activeFilters = computed(() => {
    const allowedFilters = Object.fromEntries(
      Object.entries(route.query).filter(
        ([key]) => !DEFAULT_QUERY_KEYS.includes(key)
      ).map(([key, value]) => [key, queryValueToString(value)]).filter(([_key, value]) => !!value)
    );
    return deserializeFilters(allowedFilters);
  });
  const isActiveFilter = (filter) => {
    if (!filter) {
      return Object.values(activeFilters.value).length === 0;
    }
    return isFilterActive(activeFilters.value, filter);
  };
  const applyFilters = async (filter, scrollToTop = true) => {
    const newQuery = {
      sort: route.query.sort,
      term: route.query.term,
      ...filter ? serializeFilters(filter) : {}
    };
    if (isEqual(route.query, newQuery)) {
      return;
    }
    await router.push({
      query: { ...newQuery }
    });
    if (scrollToTop) {
      window.scroll({
        behavior: "smooth",
        top: 0
      });
    }
  };
  const resetFilterUrl = async () => {
    await router.replace({ query: { term: route.query.term } });
  };
  const generateFilterParams = () => {
    return {
      where: { ...transformToWhereCondition(activeFilters.value) },
      page: getCurrentPage(route.query),
      sort: getSortByValue(route.query?.sort || "", options?.defaultSort)
    };
  };
  return {
    activeFilters,
    applyFilters,
    isActiveFilter,
    resetFilterUrl,
    productConditions: computed(() => generateFilterParams())
  };
}
